export const MESSAGES = {
  changesConfirm: 'You have made some changes in the booking details. Do you want to save the changes?'
}